<template>
  <div>TrangTaoNhomChucVu</div>
</template>

<script>
export default {
  name: "TrangTaoNhomChucVu"
};
</script>


